<template>
    <div class="container mx-auto px-2 py-4">
        <h2>Kontakt</h2>
        <form @submit.prevent="onSubmit" novalidate class="box">
                <base-input v-model.trim="contactEmail"
                            :id-prefix="'contact'"
                            name="email"
                            :validations="[{ condition: v$.contactEmail.required &&  v$.contactEmail.$error && contactEmail == '' && submitted,text:'Bitte trage deine E-Mail Adresse ein!'},{ condition: v$.contactEmail.email.$invalid &&  v$.contactEmail.$error ,text:'Bitte trage deine korrekte E-Mail Adresse ein!'}]"
                            ref="contact-email"
                            icon="email"
                            :type="'text'" label="default.email" required/>
                <base-textarea v-model.trim="contactMessage"
                            :id-prefix="'contact'"
                            name="company"
                            :validations="[{ condition: v$.contactMessage.required &&  v$.contactMessage.$error && contactMessage == '' && submitted,text:'Bitte tragen Sie Ihre Nachricht ein!'}]"
                            ref="contact-message"
                            :type="'text'" label="default.message" required/>
                <base-button type="submit" :loading="axiosCall">
                    senden
                </base-button>

        </form>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {email, required} from '@vuelidate/validators'
import {ref, computed, getCurrentInstance} from 'vue'
import {API} from "@/utils/api";

export default {
    setup() {
        const contactEmail = ref('');
        const contactMessage = ref('');
        const axiosCall = ref(false);
        const submitted = ref(false);
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;

        const rules = computed(() => ({
            contactEmail: {required, email},
            contactMessage: {required}
        }))

        const v$ = useVuelidate(rules, {contactEmail,contactMessage})

        const onSubmit = () => {

            submitted.value = true;
            v$.value.$touch()

            if (v$.value.$error) return;

            axiosCall.value = true

            const contactData = {
                email: contactEmail.value,
                message: contactMessage.value
            }

            API.post('contact', contactData).then((resp) => {

                axiosCall.value = false
                submitted.value = false;
                contactEmail.value = '';
                contactMessage.value = '';

                emitter.emit("flash-message", {
                    text: 'Vielen Dank für Ihre Nachricht! Wir werden diese schnellstmöglich bearbeiten.',
                    type: 'success'
                })
            }).catch(err => {
                axiosCall.value = false;
                submitted.value = false;
                emitter.emit("flash-message", {
                    text: err.response.data.message,
                    type: 'error'
                })
            })
        }

        return {
            contactEmail,
            contactMessage,
            axiosCall,
            onSubmit,
            submitted,
            v$
        }
    }
}
</script>
